import { GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { FLOW_VISIBILITY_LEVEL_DESCRIPTIONS, FOUNDATIONAL_FLOW_REFERENCE_CODE_REVIEW } from '../constants';
import { getByVersionKey, isGitLabMaintainedItem } from '../utils';
import AiCatalogItemField from './ai_catalog_item_field.vue';
import AiCatalogItemFieldServiceAccount from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/ai_catalog_item_field_service_account.vue?vue3';
import AiCatalogItemVisibilityField from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/ai_catalog_item_visibility_field.vue?vue3';
import TriggerField from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/trigger_field.vue?vue3';
import FormFlowDefinition from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/form_flow_definition.vue?vue3';
import FormSection from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/form_section.vue?vue3';
export default {
    name: 'AiCatalogFlowDetails',
    components: {
        GlLink,
        AiCatalogItemField,
        AiCatalogItemFieldServiceAccount,
        AiCatalogItemVisibilityField,
        FormFlowDefinition,
        FormSection,
        TriggerField
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        versionKey: {
            type: String,
            required: true
        }
    },
    computed: {
        isGitLabMaintained () {
            return isGitLabMaintainedItem(this.item);
        },
        projectName () {
            return this.item.project?.nameWithNamespace;
        },
        hasProjectConfiguration () {
            return Boolean(this.item.configurationForProject);
        },
        definition () {
            return getByVersionKey(this.item, this.versionKey).definition;
        },
        serviceAccount () {
            if (this.hasProjectConfiguration && !this.item.foundational) {
                return this.item.configurationForProject?.flowTriggers?.[0]?.user;
            }
            return this.item.configurationForGroup?.serviceAccount;
        },
        isCodeReviewFoundational () {
            return this.item.foundational && this.item.foundationalFlowReference === FOUNDATIONAL_FLOW_REFERENCE_CODE_REVIEW;
        },
        hasConfigurationContent () {
            if (this.isCodeReviewFoundational) return false;
            return Boolean(this.hasProjectConfiguration || !this.item.foundational);
        }
    },
    FLOW_VISIBILITY_LEVEL_DESCRIPTIONS
};
